import { Size } from '@vivli/shared/theme';
import React from 'react';
import { IResearchTeamMemberDetail } from '@vivli/features/data-requests/infrastructure/interface';

interface TeamMemberComponentProps {
    member: IResearchTeamMemberDetail;
    hideReviewers: boolean;
    memberName?: any;
}

export const TeamMemberComponent = ({ member, hideReviewers, memberName }: TeamMemberComponentProps) => {
    const memberFirstName = member?.firstName;
    const memberLastName = member?.lastName;

    if (hideReviewers) {
        return (
            <div style={{ paddingLeft: Size.PADDING, borderLeft: '1px solid grey' }}>
                <h3>{memberName}</h3>
                <h4>Conflicts of Interest and Plan for Management</h4>
                <div>
                    {member?.conflictsOfInterest.split('\n').map((line, index) => (
                        <div key={`${line}-${index}`}>{line}</div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div style={{ paddingLeft: Size.PADDING, borderLeft: '1px solid grey' }}>
            <h3>
                {memberFirstName} {memberLastName}
            </h3>
            {member?.email} <br />
            {member?.position} <br />
            {member?.employerOrAffiliation} <br />
            {member?.orcidId?.length > 0 && `ORCID iD: ${member.orcidId}`}
            {member?.country?.name && `Country: ${member.country.name}`}
            <h4>Education or Qualifications</h4>
            <div>
                <pre>{member?.educationOrQualifications}</pre>
            </div>
            <h4>Name of the degree</h4>
            <div>
                <pre>{member?.degree}</pre>
            </div>
            <h4>Education Institution</h4>
            <div>
                <pre>{member?.educationInstitution}</pre>
            </div>
            <h4>Discipline</h4>
            <div>
                <pre>{member?.fieldOfStudy}</pre>
            </div>
            <h4>Year Received</h4>
            <div>{member?.yearReceived}</div>
            <h4>Years of Secondary Analysis</h4>
            <div>{member?.yearsOfSecondaryAnalysis}</div>
            <h4>Conflicts of Interest and Plan for Management</h4>
            <div>
                <pre>{member?.conflictsOfInterest}</pre>
            </div>
        </div>
    );
};
